import { pdfjs } from "react-pdf";

const majorVersion = Number.parseInt(pdfjs.version, 10);
const workerExtension = majorVersion >= 4 ? "mjs" : "js";

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.${workerExtension}`;

export { pdfjs };
